export default __webpack_public_path__ + "static/media/add.a9ec1d72.svg";